import { render, staticRenderFns } from "./EditImportedCustomer.vue?vue&type=template&id=74535475&scoped=true&"
import script from "./EditImportedCustomer.vue?vue&type=script&lang=js&"
export * from "./EditImportedCustomer.vue?vue&type=script&lang=js&"
import style0 from "./EditImportedCustomer.vue?vue&type=style&index=0&id=74535475&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74535475",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VCard,VCol,VRow,VSpacer,VTab,VTabItem,VTabs,VTabsItems,VToolbar})
